import styled from "styled-components";
import Dialog from "../../../../components/dialog/dialog";

export const CreateRateStyled = styled(Dialog)`
  width: 35%;

  button {
    color: #301d35 !important;
    border: 1px solid #301d35;
  }

  .dialog-body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;
